import { Component, Input } from '@angular/core';
import { CoreService } from 'src/app/services/core.service';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-branding',
  imports: [RouterModule],
  template: `
    <a [routerLink]="['/']" class="logodark">
      <img
        src="./assets/images/logos/logo-yrix.png"
        class="align-middle branding-logo"
        [class.branding-logo--compact]="compact"
        alt="Logo de Yrix.ai - Visión Artificial e Inteligencia para el Control de Accesos"
        loading="lazy"
      />
    </a>

    <a [routerLink]="['/']" class="logolight">
      <img
        src="./assets/images/logos/logo-yrix-dark.png"
        class="align-middle branding-logo"
        [class.branding-logo--compact]="compact"
        alt="Logo de Yrix.ai - Visión Artificial e Inteligencia para el Control de Accesos"
        loading="lazy"
      />
    </a>
  `,
  styles: [
    `
      .branding-logo {
        max-width: 210px;
        width: 100%;
        height: auto;
        margin: 12px auto 20px;
        display: inline-block;
      }

      @media (max-width: 768px) {
        .branding-logo {
          max-width: 160px;
        }
      }

      .branding-logo--compact {
        width: auto;
        height: 80px;
        max-width: 100%;
        max-height: 80px;
        margin: 0 auto;
        display: block;
      }

      :host-context(.sidebarNav-mini) .branding-logo--compact {
        width: 100%;
        height: auto;
        max-height: 48px;
        max-width: 100%;
        object-fit: contain;
        object-position: center;
        margin: 0 auto;
      }

      :host-context(.sidebarNav:hover) .branding-logo--compact {
        width: auto;
        height: 80px;
        max-height: 80px;
        max-width: 100%;
        object-fit: contain;
      }
    `,
  ],
})
export class BrandingComponent {
  @Input() compact = false;

  options = this.settings.getOptions();
  constructor(private settings: CoreService) {}
}
